import ticketsApi from '../../api/tickets-api';
import router from '@/router';
import tablesApi from '@/api/tables-api';

const tickets = {
  items: [],
  item: {},
  itemsTotal: 0,
  popupSeeTicket: false,
  statusSelect: [],
};

const mutations = {
  setItemsTickets (state, payload) {
    state.items = payload.data;
  },
  setItemsTotalTickets (state, payload) {
    state.itemsTotal = payload;
  },
  setItemTicket (state, payload) {
    state.item = payload;
  },
  setpopupSeeTicket (state, payload) {
    state.popupSeeTicket = payload;
  },
  setSelectStatusTickets (state, payload) {
    state.statusSelect = payload;
  },
};

const actions = {
  async refreshTickets (
    context,
    { restaurant_id, tables, status, page, per_page, search = '', date_from = '', date_to = '', language },
  ) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    context.commit('loading', true);
    const res = await ticketsApi.getAllByRestaurant(
      restaurant_id,
      tables,
      status,
      page,
      per_page,
      search,
      date_from,
      date_to,
      language,
    );
    context.commit('loading', false);
    context.commit('setItemsTickets', res.data);
    context.commit('setItemsTotalTickets', res.data.meta.total);
  },
  async getTicket (context, { id, language }) {
    context.commit('setItemTicket', {});
    const res = await ticketsApi.getOne(id, language);
    context.commit('setItemTicket', res.data.data);
  },
  downloadTicket ({ commit }, id) {
    commit('loading', true);
    ticketsApi.download(id).then(
      (response) => {
        const file = new Blob([response.data], { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL);
        commit('loading', false);
      },
      (error) => {
        commit('loading', false);
      },
    );
  },
  async getSelectStatusTickets (context, language) {
    const res = await ticketsApi.getListSelectStatus(language);
    context.commit('setSelectStatusTickets', res.data);
  },
};

const getters = {
  getTickets: (state) => state.items,
  getTicketsTotal: (state) => state.itemsTotal,
  getTicket: (state) => state.item,
  getpopupSeeTicket: (state) => state.popupSeeTicket,
  getSelectStatusTickets: (state) => state.statusSelect,
};

export default {
  state: tickets,
  mutations,
  actions,
  getters,
};
